module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"YEARLING":"Yearling","YEAR2":"2 ans","YEAR3":"3 ans","CAE":"CAE","MARE":"Jument","MAIDEN":"Maiden","STORE2":"Store 2","STORE3":"Store 3","STALLION":"Étalon","STALLION_PART":"Part d\u0027étalon","FOAL":"Foal","BREEDING_RIGHT":"Breeding right"}}')
  delete Component.options._Ctor
}
